import type { RecalculateRiskScoresMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { RecalculateRiskScoresDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

/**
 * recalculateRiskScores (RSP-6156) — a no-input trigger. On the tRPC path the
 * mutation resolves once the async request completes (the data-layer emits the
 * trigger, event-consumers recomputes, and the RiskScoresRecalculated
 * completion event closes the request-state-api request).
 */
export const useRecalculateRiskScores = createMutationHook({
  name: 'recalculateRiskScores',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.aggregation.recalculateRiskScores.mutationOptions({
      onSuccess,
    }),
  mapInput: (_input: void) => undefined,
  // Consumers ignore the payload — the scores land asynchronously.
  mapResponse: (): RecalculateRiskScoresMutation => ({
    recalculateRiskScores: {
      __typename: 'RecalculateRiskScoresOutput',
      message: null,
    },
  }),
  graphqlDocument: RecalculateRiskScoresDocument,
  graphqlVariables: () => ({}),
});
